<div class="sidebar-mobile">
  @if (isLoggedIn()) {
    <div class="sidebar-mobile__account">
      <a
        [routerLink]="routes.ACCOUNT"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="sidebar-mobile__profile--active"
        class="sidebar-mobile__profile">
        <avatar
          [name]="userName()!"
          [src]="userImage()"
          shape="circle"
          size="xl"
          class="sidebar-mobile__avatar" />
        <div class="sidebar-mobile__user">
          <span class="sidebar-mobile__user-name">{{ userName() }}</span>
          @if (userEmail()) {
            <span class="sidebar-mobile__user-caption">{{ userEmail() }}</span>
          }
          <span class="sidebar-mobile__user-link">Ver mi perfil</span>
        </div>
      </a>

      <a [routerLink]="routes.ACCOUNT_SETTINGS" class="sidebar-mobile__settings">
        <span class="sidebar-mobile__settings-icon">
          <ng-container *ngComponentOutlet="SettingTwoOutline" />
        </span>
        <span class="sidebar-mobile__settings-text">
          <span class="sidebar-mobile__settings-title">Configuración</span>
          <span class="sidebar-mobile__settings-caption">Edita tu nombre, foto y contraseña</span>
        </span>
      </a>
    </div>

    <div class="sidebar-mobile__group">
      <nav-item
        [icon]="BookOutline"
        [routerLink]="routes.MY_COURSES"
        label="Mis cursos"
        size="large"
        class="sidebar-mobile__item" />
      <nav-item
        [icon]="CalendarOutline"
        [routerLink]="routes.CALENDAR"
        label="Mi calendario"
        size="large"
        class="sidebar-mobile__item" />
      <nav-item
        [icon]="MedalStarOutline"
        [routerLink]="routes.MY_CERTIFICATES"
        label="Mis certificados"
        size="large"
        class="sidebar-mobile__item" />
    </div>
  }

  <div class="sidebar-mobile__group sidebar-mobile__group--mobile">
    <nav-item
      [routerLink]="routes.COURSES"
      label="Cursos"
      size="large"
      class="sidebar-mobile__item" />
    <nav-item
      [routerLink]="routes.ABOUT_US"
      label="Nosotros"
      size="large"
      class="sidebar-mobile__item" />
    <nav-item
      [activeOptions]="{ exact: false }"
      [routerLink]="routes.CERTIFICATES_VALIDATE"
      label="Validar certificado"
      size="large"
      class="sidebar-mobile__item" />
  </div>

  <div class="sidebar-mobile__group">
    <nav-item
      [icon]="ShoppingCartOutline"
      [routerLink]="routes.CART"
      label="Carrito"
      size="large"
      class="sidebar-mobile__item sidebar-mobile__item--mobile" />
    @if (isLoggedIn()) {
      <nav-item
        [icon]="ShoppingBagOutline"
        [routerLink]="routes.PURCHASE_HISTORY"
        label="Mis compras"
        size="large"
        class="sidebar-mobile__item" />
    }
  </div>

  <div class="sidebar-mobile__group sidebar-mobile__group--mobile">
    <nav-item
      (click)="toggleDarkMode()"
      [icon]="themeIcon()"
      [label]="themeLabel()"
      size="large"
      class="sidebar-mobile__item" />
    <dropdown-form-control
      (valueChange)="setCurrency($event)"
      [icon]="DollarCircleBold"
      [options]="currencyOptions"
      [value]="currentCode()"
      size="large"
      class="sidebar-mobile__item sidebar-mobile__item--currency" />
  </div>

  @if (isLoggedIn()) {
    <div class="sidebar-mobile__footer">
      <primary-button
        (click)="logout()"
        [icon]="LogoutOutline"
        label="Cerrar sesión"
        variant="secondary"
        class="sidebar-mobile__logout" />
    </div>
  }
</div>
